import { render, staticRenderFns } from "./time-panel.vue?vue&type=template&id=38c5c54c&"
import script from "./time-panel.vue?vue&type=script&lang=js&"
export * from "./time-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports